'use client'
import {Button, ConfigProvider, Divider, Drawer, Flex, Image, Menu, Typography} from "antd";
import {MenuOutlined} from "@ant-design/icons";
import React, {useEffect, useState} from "react";
import {useLocale, useTranslations} from "next-intl";
import {LoggerService} from "@/src/services/logger";
import {Locale, usePathname, useRouter} from "@/src/i18n/routing";
import {useParams, useSearchParams} from "next/navigation";
import {MediaQueryEnum} from "@ant-design/pro-utils/lib/useMediaQuery";
import useWindowDimensions from "@/src/hooks/useWindowDimensions";
import {inter, roboto} from "@/src/app/fonts";
import {MenuItemType} from "antd/lib/menu/interface";
import {Constants} from "@/src/lib/constants";
import {ThemeService} from "@/src/services/theme";
import {Helper} from "@/src/lib/helper";
const { Link } = Typography

type Props = {
    // onMenuClick: (itemKey: React.Key) => void
};
const HeaderComponent = (props: Props) => {
    const localization = useTranslations('header');
    const generalLocalization = useTranslations('general');
    const themeColors = ThemeService.getThemeColors()
    const router: any = useRouter()
    const pathname = usePathname();
    const params = useParams();
    const searchParams = useSearchParams()
    const locale = useLocale();
    const [drawerOpened, setDrawerOpened] = useState(false)
    const {width, height} = useWindowDimensions()
    const [isLargeScreen, setIsLargeScreen] = useState<boolean>(true)
    const [isLoaded, setIsLoaded] = useState(false)
    const handleLanguageChange = (value: string) => {
        LoggerService.getLogger().debug(`selected ${value}`);
        const nextLocale = value as Locale;

        const queryString = searchParams.toString();
        const updatedPath = queryString ? `${pathname}?${queryString}` : pathname

        router.replace(
            {pathname: updatedPath, params: params},
            {locale: nextLocale}
        );
    };

    const items = [
        {key: "company", label: localization("menuCompany").toUpperCase()},
        {key: "services", label: localization("menuServices").toUpperCase()},
        {key: "lodgings", label: localization("menuLodgings").toUpperCase()},
        {key: "reviews", label: localization("menuReviews").toUpperCase()},
        {key: "contacts", label: localization("menuContacts").toUpperCase()}
    ]

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        setIsLargeScreen(Helper.checkLargeScreen())
        LoggerService.getLogger().debug(`<<< lg: ${MediaQueryEnum.lg.minWidth}`)
        setIsLoaded(true)
        function handleResize() {
            setIsLargeScreen(Helper.checkLargeScreen())
            // setDrawerOpened(false)
        }

    }, []);

    useEffect(() => {
        setDrawerOpened(false)

    }, [useWindowDimensions()]);

    const onMenuItemClicked = (item: MenuItemType) => {
        switch(item.key) {

            case "company":
                router.push("home#company");
                break
            case "services":
                router.push("home#services")
                break
            case "lodgings":
                router.push("home#lodgings")
                break
            case "reviews":
                router.push("home#reviews")
                break
            case "contacts":
                router.push("home#contacts")
                break
            default:
                break
        }
        // props.onMenuClick(item.key)
    }

    return <>

        {(() => {
            if (!isLoaded) {
                return <></>
            } else {
                return <ConfigProvider
                    theme={{
                        components: {
                            Carousel: {
                                arrowSize: 48,
                                arrowOffset: 32,
                                dotHeight: 5,
                                dotWidth: 24,
                                dotActiveWidth: 36,
                                dotOffset: 48
                            },
                            Menu: {
                                collapsedWidth: 20,
                                horizontalItemHoverColor: themeColors.secondary,
                                itemColor: themeColors.secondary,
                                itemHoverColor: themeColors.tertiary,
                                itemBg: themeColors.tertiary,
                                itemHeight: isLargeScreen ? "20px" : "50px",
                                horizontalLineHeight: "35px!important",
                                horizontalItemSelectedColor: themeColors.menuBarColor,
                                lineType: "none",
                                lineHeight: 40
                            },
                            Button: {
                                defaultBg: themeColors.primary,
                                defaultColor: themeColors.tertiary,
                                // defaultHoverBg: themeColors.secondary,
                                // defaultHoverColor: themeColors.tertiary,
                                defaultActiveBg: themeColors.secondary,
                                defaultActiveColor: themeColors.tertiary,
                                defaultActiveBorderColor: themeColors.tertiary,
                                defaultHoverBorderColor: themeColors.primary
                            },
                            Input: {
                                activeBorderColor: themeColors.primary,
                                hoverBorderColor: themeColors.primary,
                                activeShadow: "0 0 0 2px rgba(169, 34, 22, 0.1)"
                            },
                            Select: {
                                activeOutlineColor: "transparent",
                                lineType: "none"
                            },
                            Tabs: {
                                itemSelectedColor: themeColors.primary,
                                itemHoverColor: themeColors.secondary,
                                itemActiveColor: themeColors.primary,
                                inkBarColor: themeColors.primary
                            },
                            Drawer: {
                                colorIcon: themeColors.secondary,
                                colorIconHover: themeColors.tertiary,
                                colorSplit: themeColors.secondary,
                                colorBgElevated: "#0B1527"
                            }
                        },
                        token: {
                            fontFamily: roboto.style.fontFamily,
                            colorLink: themeColors.tertiary,
                            colorLinkHover: themeColors.menuBarColor
                        }
                    }}
                >
                    <div style={{fontFamily: `${inter.style.fontFamily}`, backgroundColor: "#000"}}>
                        <Flex justify={width >= MediaQueryEnum.sm.minWidth ? "space-between" : "end"} style={{marginTop: 10}} align={"center"}>
                            {(() => {
                                if (width >= MediaQueryEnum.sm.minWidth) {
                                    return (
                                        <Flex justify={"start"} style={{marginTop: 10}} align={"center"}>

                                            <Image alt="" src="/assets/place.png" height={32} preview={false} style={{verticalAlign: "unset", width: "auto"}}/>
                                            <div style={{margin: "0 10px"}}>
                                                <p style={{
                                                    margin: 0,
                                                    padding: 0,
                                                    lineHeight: "normal",
                                                    fontSize: 14,
                                                    color: `${themeColors.secondary}`
                                                }}>{Constants.companyAddress}</p>
                                                <p style={{marginTop: 2, padding: 0, lineHeight: "normal", fontSize: 12, color: `${themeColors.secondary}`}}>{Constants.companyCity}</p>
                                            </div>
                                        </Flex>
                                    )
                                }
                            })()}


                            <Flex justify={"start"} style={{marginTop: 10}} align={"center"}>
                                {(() => {
                                    if (width >= MediaQueryEnum.sm.minWidth) {
                                        return (
                                            <>
                                                <Image alt="" src="/assets/headphones.png" height={32} preview={false} style={{verticalAlign: "unset", width: "auto", color:"red"}}/>
                                                <div style={{margin: "0 10px"}}>
                                                    <p style={{
                                                        margin: 0,
                                                        padding: 0,
                                                        lineHeight: "normal",
                                                        fontWeight: 600,
                                                        fontSize: 14,
                                                        color: `${themeColors.secondary}`
                                                    }}>{localization("info")}</p>
                                                    <p style={{marginTop: 2, padding: 0, lineHeight: "normal", fontSize: 12, color: `${themeColors.secondary}`}}>
                                                        <Link className={"mapLink"} href={`tel: ${Constants.companyPhone}`} target={"_blank"}>{Constants.companyPhone}</Link>
                                                    </p>
                                                </div>
                                            </>
                                        )

                                    }
                                })()}
                                <Button
                                    className={"languageSelector"}
                                    onClick={() => handleLanguageChange(locale == "it" ? "en" : "it")}
                                >
                                    {locale == "it" ? "EN" : "IT"}
                                </Button>

                                <Button
                                    className={"languageSelector"}
                                    style={{marginLeft: 10}}
                                    // onClick={() => {window.open(Constants.happyRentalsLink, "_blank")}}
                                    // onClick={() => { router.push("home#lodgings")}}
                                >
                                    <Link className={"mapLink light noEffect"} href={Constants.whatsappLink} target={"_blank"}>{localization("whatsappLbl").toUpperCase()}</Link>
                                </Button>
                            </Flex>
                        </Flex>
                        <Divider style={{marginTop: 10, marginBottom: 20, backgroundColor: "#FFF", opacity: 0.7}}/>
                        <Flex align={"center"} justify={"start"}>
                            <Flex flex={"fit-content"}>
                                <Link href={"home"}>

                                    <Image
                                        // height={100}
                                        src="/assets/logo.png"
                                        preview={false}
                                        style={{maxHeight: 55, width: "auto"}}
                                        alt=""
                                    />
                                </Link>
                            </Flex>
                            <Flex align={"center"} justify={"end"}>
                                {(() => {

                                    if (width >= MediaQueryEnum.md.minWidth) {
                                        return (
                                            <>
                                                <Menu
                                                    theme="light"
                                                    mode="horizontal"
                                                    items={items}
                                                    disabledOverflow={true}
                                                    style={{minWidth: 0, flex: "auto", backgroundColor: `${themeColors.primary}`}}
                                                    onClick={(item)=> onMenuItemClicked(item)}
                                                />
                                            </>
                                        )
                                    } else {
                                        return (
                                            <>
                                                <Button
                                                    type={"default"}
                                                    icon={<MenuOutlined/>}
                                                    onClick={(e) => setDrawerOpened(!drawerOpened)}
                                                />
                                                <Drawer open={drawerOpened} onClose={() => setDrawerOpened(false)} >
                                                    <Menu
                                                        theme="dark"
                                                        mode="vertical"
                                                        items={items}
                                                        disabledOverflow={true}
                                                        onClick={(item)=> {
                                                            onMenuItemClicked(item)
                                                            setDrawerOpened(false)
                                                        }}
                                                    />
                                                </Drawer>
                                            </>
                                        )
                                    }
                                })()}

                            </Flex>

                        </Flex>
                        <Divider style={{marginTop: 20, marginBottom: 20}}/>
                    </div>
                </ConfigProvider>
            }
        })()}
    </>
}

export default HeaderComponent